import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CaseStudyCard = ({ caseStudy, onViewDetails }) => {
  const getIndustryIcon = (industry) => {
    const icons = {
      'Technology': 'Laptop',
      'Real Estate': 'Building',
      'Manufacturing': 'Factory',
      'Family Business': 'Users',
      'Healthcare': 'Heart',
      'Financial Services': 'CreditCard'
    };
    return icons?.[industry] || 'Briefcase';
  };

  const getServiceTypeColor = (serviceType) => {
    const colors = {
      'Transaction Support': 'bg-blue-100 text-blue-800',
      'Litigation Support': 'bg-red-100 text-red-800',
      'Financial Reporting': 'bg-green-100 text-green-800',
      'Business Valuation': 'bg-purple-100 text-purple-800',
      'IP Valuation': 'bg-orange-100 text-orange-800'
    };
    return colors?.[serviceType] || 'bg-gray-100 text-gray-800';
  };

  const getCompanySizeColor = (size) => {
    const colors = {
      'Startup': 'bg-emerald-100 text-emerald-800',
      'SME': 'bg-yellow-100 text-yellow-800',
      'Large Enterprise': 'bg-indigo-100 text-indigo-800',
      'Family Office': 'bg-pink-100 text-pink-800'
    };
    return colors?.[size] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-brand-lg transition-all duration-300 hover-lift">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-12 h-12 bg-accent/10 rounded-lg">
            <Icon name={getIndustryIcon(caseStudy?.industry)} size={24} className="text-accent" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary mb-1">
              {caseStudy?.title}
            </h3>
            <p className="text-sm text-text-secondary">
              {caseStudy?.industry} • {caseStudy?.duration}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getServiceTypeColor(caseStudy?.serviceType)}`}>
            {caseStudy?.serviceType}
          </span>
        </div>
      </div>
      <p className="text-text-secondary text-sm mb-4 line-clamp-3">
        {caseStudy?.challenge}
      </p>
      <div className="flex items-center justify-between mb-4">
        <span className={`px-3 py-1 rounded-full text-xs font-medium ${getCompanySizeColor(caseStudy?.companySize)}`}>
          {caseStudy?.companySize}
        </span>
        <div className="flex items-center space-x-4 text-sm text-text-secondary">
          <div className="flex items-center space-x-1">
            <Icon name="MapPin" size={14} />
            <span>{caseStudy?.location}</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Calendar" size={14} />
            <span>{caseStudy?.year}</span>
          </div>
        </div>
      </div>
      <div className="border-t border-border pt-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="text-center">
              <div className="text-lg font-semibold text-accent">
                {caseStudy?.outcome?.valueRange}
              </div>
              <div className="text-xs text-text-secondary">Valuation Range</div>
            </div>
            <div className="text-center">
              <div className="text-lg font-semibold text-success">
                {caseStudy?.outcome?.timeline}
              </div>
              <div className="text-xs text-text-secondary">Completion</div>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            iconName="ArrowRight"
            iconPosition="right"
            iconSize={16}
            onClick={() => onViewDetails(caseStudy)}
          >
            View Details
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CaseStudyCard;